define('modules/searcher',["jquery", "app", "fuse"], function($, App, Fuse) {
    function Searcher() {
        var productSearcher = new Fuse(App.global('products'), {
            shouldSort: true,
            threshold: 0.2,
            maxPatternLength: 32,
            keys: [
                "name"
            ]
        });

        this.search = function(term, callback) {
            App.api.call('/product.search', {term : term, store_id: App.global('store')}, function(response) {
                processProducts(response.data);
            },function(message) {
                processProducts(productSearcher.search(term));
            }).fail(function(){
                processProducts(productSearcher.search(term));
            });

            function processProducts(products) {
                App.database.instance.products
                    .where("id")
                    .anyOf(products.map(function(p){return p.id;}))
                    .toArray(callback);
            }
        };
    }
    return Searcher;
});
